export default "__VITE_ASSET__D6$YEv0k__"